const Loading = ({ className }: { className?: string }) => (
  <div className={`container text-center ${className || ""}`}>
    <img src="/images/ellipsis-3s-90px/Ellipsis-3s-90px.svg" alt="Loading..." style={{ maxWidth: 100 }} />
  </div>
);

export default Loading;
